module.exports = __webpack_public_path__ + "static/media/women.569dd5bd.jpeg";